/**
 * Turns an API location from the env files into an absolute URL.
 *
 * The env files mix three styles, and only the first is safe to hand to fetch() as-is:
 *  - "https://host/avatar-core/api/faq/active"  absolute: returned untouched
 *  - "/avatar-audit/api/user-experience"        gateway-rooted: a sibling service of avatar-core
 *  - "api/faq/active"                           relative to REACT_APP_BASE_URL (avatar-core)
 *
 * A relative value passed straight to fetch() resolves against the SPA's own origin, where
 * nginx answers 200 with index.html for every unknown path. That made a feedback POST "succeed"
 * without ever reaching the audit service, and the FAQ GET receive HTML instead of JSON.
 */
const isAbsolute = (value: string): boolean => /^https?:\/\//i.test(value);

const trimSlashes = (value: string): string => value.replace(/\/+$/, "");

const coreBaseUrl = (): string => trimSlashes((process.env.REACT_APP_BASE_URL ?? "").trim());

/** The gateway root the services hang off: REACT_APP_BASE_URL without its "/avatar-core" segment. */
export const gatewayBaseUrl = (): string => coreBaseUrl().replace(/\/avatar-core$/i, "");

export const resolveApiUrl = (value: string | null | undefined): string => {
  const location = (value ?? "").trim();
  if (!location) return "";
  if (isAbsolute(location)) return location;
  if (location.startsWith("/")) return `${gatewayBaseUrl()}${location}`;
  return `${coreBaseUrl()}/${location}`;
};
